import { defineFieldConfigMap } from "@/components/shared/UniversalCRMTable/types/field-config-types";
import {
  ALL_STAFF_ROLES,
  ALL_STAFF_AND_CLIENT_ROLES,
} from "@west-tennessee-consulting/hub-roles";

// Deal-related fields derived from the contact's company.
// Trigger-maintained on the contacts table; see
// supabase/migrations/20260526000000_add_contact_company_deal_metrics.sql.
export const dealsContactFields = defineFieldConfigMap({
  // FIELD: has_active_deals
  has_active_deals: {
    type: "boolean",
    label: "Company Has Deals",
    mobileDetailSectionId: "company",
    sortable: true,
    filterable: true,
    searchable: false,
    resizable: true,
    hideable: true,
    editable: false,
    excludeFromApi: true,
    isReadOnlyDerived: true,
    readOnlyReason:
      "Maintained automatically from the contact's company. Reflects whether the company has at least one active sales-pipeline deal.",
    dataLineage: {
      kind: "denormalized",
      sourceTable: "companies",
      sourceField: "has_active_deals",
      sourceForeignKeyField: "company_id",
      notes:
        "Mirrored from the company's trigger-populated has_active_deals column. Updated when the contact's company_id changes or the company's deal metrics change.",
    },
    filterType: "exact",
    width: 140,
    minWidth: 110,
    maxWidth: 180,
    icon: "Briefcase",
    groupable: true,
    allowedRoles: [...ALL_STAFF_ROLES],
    showOnCard: true,
    cardSpan: 1,
    graphqlSelector: "has_active_deals",
    savedViewMembership: [
      "contacts-with-active-deals",
      "contacts-without-active-deals",
    ],
  },
  // FIELD: active_deal_count
  active_deal_count: {
    type: "number",
    label: "Company Active Deals",
    mobileDetailSectionId: "company",
    sortable: true,
    filterable: true,
    searchable: false,
    resizable: true,
    hideable: true,
    editable: false,
    excludeFromApi: true,
    isReadOnlyDerived: true,
    readOnlyReason:
      "Maintained automatically from the contact's company. Reflects the count of active sales-pipeline deals at the company.",
    dataLineage: {
      kind: "denormalized",
      sourceTable: "companies",
      sourceField: "active_deal_count",
      sourceForeignKeyField: "company_id",
      notes:
        "Mirrored from the company's trigger-populated active_deal_count column.",
    },
    filterType: "range",
    width: 150,
    minWidth: 120,
    maxWidth: 180,
    icon: "Briefcase",
    groupable: true,
    allowedRoles: [...ALL_STAFF_ROLES],
    showOnCard: true,
    cardSpan: 1,
    graphqlSelector: "active_deal_count",
    savedViewMembership: ["contacts-with-active-deals"],
  },
});
